var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.92486 0 0 4.92486 0 11C0 17.0751 4.92486 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92486 17.0751 0 11 0ZM9.24034 15.8941L4.57726 11.231L6.18294 9.62534L9.24034 12.6827L15.8171 6.10594L17.4228 7.71167L9.24034 15.8941Z",
    fill: "#6A097D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCheckedIcon);
export default __webpack_public_path__ + "static/media/pricingCheckedIcon.5babcf375bff52d8af03c963a80b1626.svg";
export { ForwardRef as ReactComponent };